import './index.less';
import EbHeader from './header/index';
import EbIcon from './icon/index';
import EbMenu from './menu/index';
import EbSubmenu from './submenu/index';
import EbMenuItem from './menu-item/index';
import EbSteps from './steps/index';
import EbStep from './step/index';

const components = [
  EbHeader,
  EbIcon,
  EbMenu,
  EbMenuItem,
  EbSteps,
  EbStep,
  EbSubmenu,
];

const install = (Vue) => {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

export default {
  install,
};
